import React from 'react';
import T from 'prop-types';

import { FLEX_DRAFT_DRAWER_DICTIONARY } from '@dmi/shared/redux/Payments/FlexDraft/constants';

import iconDictionary from '../../../../utils/iconDictionary';
import { AddAccountContainer, SecondAccountButton } from './styledComponents';

const AddIcon = iconDictionary('addCircle');

const SecondAccountAdd = ({ dispatchSetIsSecondAccountFormEnabled }) => (
  <AddAccountContainer>
    <SecondAccountButton
      Icon={AddIcon}
      isPrimary
      label={FLEX_DRAFT_DRAWER_DICTIONARY.sources.secondAccountText}
      onPress={() => dispatchSetIsSecondAccountFormEnabled(true)}
    />
  </AddAccountContainer>
);

SecondAccountAdd.propTypes = { dispatchSetIsSecondAccountFormEnabled: T.func.isRequired };

export default SecondAccountAdd;
